"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CartItemFactory = exports.CartsFactory = void 0;
const types_1 = require("../types");
class CartsFactory {
    static sample(cart) {
        return {
            note: 'notes',
            items: [],
            links: {
                self: new types_1.Link({ href: 'www.boclips.com/cart' }),
                addItem: new types_1.Link({ href: 'www.boclips.com/cart' }),
            },
            ...cart,
        };
    }
}
exports.CartsFactory = CartsFactory;
class CartItemFactory {
    static sample(item) {
        return {
            id: 'cart-item-id',
            videoId: 'video-id',
            additionalServices: null,
            links: {
                self: new types_1.Link({
                    href: 'www.app.boclips.com/cart/items/cart-item-id',
                }),
                additionalServices: new types_1.Link({
                    href: 'www.app.boclips.com/cart/items/cart-item-id/additional-services',
                }),
            },
            ...item,
        };
    }
}
exports.CartItemFactory = CartItemFactory;
//# sourceMappingURL=CartsFactory.js.map